// Mock data for Kiua Music Group

export const NAV_LINKS = [
  { id: 'home', label: 'HOME', href: '#home' },
  { id: 'about', label: 'ABOUT', href: '#about' },
  { id: 'contact', label: 'CONTACT', href: '#contact' },
];

export const FOOTER_LINKS = [
  { id: 'ig', label: 'INSTAGRAM', href: 'https://www.instagram.com/kiuamusicgroupllc/', icon: 'instagram' },
  { id: 'x', label: 'X', href: 'https://x.com/kiuamusicgroup', icon: 'x' },
  { id: 'discord', label: 'DISCORD', href: 'https://discord.gg/s84XDx5t5y', icon: 'discord' },
  { id: 'email', label: 'EMAIL', href: 'mailto:contact@kiuamusicgroup.com', icon: 'mail' },
];

export const ABOUT_TEXT =
  'Kiua Music Group is a modern record label built on transparency and global vision. By putting artists first, we deliver clear communication, fast action, and professional discipline. We don\u2019t just release music; we set a higher standard for the modern music industry through honesty and execution.';

export const SERVICES = [
  {
    id: 'dsp',
    title: 'DSP PITCHING',
    description: 'Direct relationships with editorial teams at Spotify, Apple Music, Amazon, Deezer and more to land your records on the playlists that matter.',
    tag: '01',
  },
  {
    id: 'creative',
    title: 'CREATIVE DIRECTION',
    description: 'Cohesive artist identity \u2014 visuals, motion design, art direction and brand systems built to scale across platforms.',
    tag: '02',
  },
  {
    id: 'viral',
    title: 'VIRAL MARKETING',
    description: 'Performance-driven campaigns across TikTok, Reels and Shorts engineered to break records and accelerate growth curves.',
    tag: '03',
  },
  {
    id: 'radio',
    title: 'RADIO & PRESS',
    description: 'Global radio servicing and press placements with tier-1 outlets, magazines, podcasts and influencer networks.',
    tag: '04',
  },
  {
    id: 'content',
    title: 'CONTENT STRATEGY',
    description: 'Always-on content engines: short-form, long-form, livestreams. We treat artists like media companies.',
    tag: '05',
  },
  {
    id: 'distribution',
    title: 'DISTRIBUTION',
    description: 'Transparent royalty flow, fast payouts and full ownership retention through our global distribution partners.',
    tag: '06',
  },
];

export const STATS = [
  { id: 's1', value: '200M+', label: 'Total Streams' },
  { id: 's2', value: '60+', label: 'Releases' },
  { id: 's3', value: '30+', label: 'Countries' },
  { id: 's4', value: '24/7', label: 'Artist Support' },
];

export const ROSTER = [
  { id: 'a1', name: 'ZWELLA', genre: 'Electronic / Future Bass', spotifyUrl: 'https://open.spotify.com/artist/1FXPLxnSOO6iRA1W0DVY1x' },
  { id: 'a2', name: 'KAI MIRA', genre: 'Indie Pop / Synth' },
  { id: 'a3', name: 'PHANTOM LINE', genre: 'House / Tech' },
  { id: 'a4', name: 'ASTRA', genre: 'Bass / Trap' },
  { id: 'a5', name: 'ECHO REIGN', genre: 'Alternative R&B' },
  { id: 'a6', name: 'VOLTA', genre: 'Drum & Bass' },
];

export const EMAILS_MARQUEE = [
  'contact@kiuamusicgroup.com',
  'legal@kiuamusicgroup.com',
  'demos@kiuamusicgroup.com',
];
